import { useState, useEffect, useContext } from "react";
import { getHeaders } from "../../utils/HeaderHelper";
import { AuthenticationContext } from "../../Context";
import { useFlash } from "../../FlashContext"; 

const useFetchAssignmentHistories = (
  patientId,
  assignmentType,
  reFetchingKey
) => {
  const [assignmentHistories, setAssignmentHistories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const authenticationSetting = useContext(AuthenticationContext);
  
  const { showToast } = useFlash();

  useEffect(() => {
    const fetchHistories = async () => {
      if (!patientId) return; // Guard clause

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `/patients/${patientId}/assignment_histories?assignment_type=${assignmentType}`,
          {
            method: "GET",
            headers: getHeaders(authenticationSetting.csrfToken),
          }
        );
        
        const result = await response.json();

        if (response.ok) {
          setAssignmentHistories(result.resource || []);
        } else {
          const errorMessage = result.error || `Error fetching ${assignmentType} history.`;
          setError(errorMessage);
          showToast({ title: "Fetch Error", text: errorMessage, type: "error" });
        }
      } catch (err) {
        const fallbackMessage = `System error while fetching ${assignmentType} history.`;
        setError(fallbackMessage);
        
        showToast({ 
          title: "Connection Error", 
          text: fallbackMessage, 
          type: "error" 
        });
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchHistories();
  }, [patientId, assignmentType, reFetchingKey]);

  return { assignmentHistories, loading, error };
};

export default useFetchAssignmentHistories;